import { apiWithToken } from '../api';

const resouceUrl = '/vistoria';
const token = localStorage.getItem('@token');
let api = apiWithToken(token);

export const load = async (params) => {
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  let page = urlParams.has('page') ? { page: urlParams.get('page') } : {};
  let search = urlParams.has('search')
    ? { search: urlParams.get('search') }
    : {};
  return await api.get(`${resouceUrl}`, {
    params: {
      ...params,
      ...page,
      ...search,
    },
  });
};

export const getVistoria = async (id) => {
  return await api.get(`${resouceUrl}/${id}`);
}

export const show = async (id) => {
  return await api.get(`${resouceUrl}/${id}`);
}

export const update = async (id, vistoria) => {
  return await api.put(`${resouceUrl}/${id}`, vistoria);
}

export const store = async (vistoria) => {
  let response = await api.post(resouceUrl , vistoria);
  return response;
}

export const destroy = async (id) => {
  return await api.delete(`${resouceUrl}/${id}/remove`);
}

export const entidade = async (params) => {
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  let page = urlParams.has('page') ? { page: urlParams.get('page') } : {};
  let search = urlParams.has('search')
    ? { search: urlParams.get('search') }
    : {};
  return await api.get(`${resouceUrl}_entidade`, {
    params: {
      ...params,
      ...page,
      ...search,
    },
  });
}
